import {Component, OnInit} from '@angular/core';
import {RequestsService} from '@app/services/requests.service';
import {DataService} from '@app/services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {User, LoginRequest} from '#defs';
import {NbAuthService, NbTokenService} from '@nebular/auth';
import {NbAuthResult} from '@nebular/auth/services/auth-result';
import {SeoService} from '@app/services/seo.service';
import {AnalyticsService} from '@app/services/analytics.service';
import {environment} from '#env';
import {UtilService} from '@app/services/util.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {

  user: User;
  error: string;
  submitted = false;
  loginReq: LoginRequest;
  realToken: any;
  tax: 'SST' | 'TIN' = environment.countryLong === 'Malaysia' ? 'SST' : 'TIN';

  constructor(private requests: RequestsService,
              private route: ActivatedRoute,
              private router: Router,
              private token: NbTokenService,
              private dataService: DataService,
              private authService: NbAuthService,
              public utilService: UtilService,
              private seo: SeoService,
              private analytics: AnalyticsService) {
    this.user = this.dataService.user;
    this.loginReq = {
      password: '',
      email: '',
      username: this.user.email
    };
  }

  ngOnInit(): void {
    this.analytics.track('Password Reset Page Viewed');

    this.seo.generateTags({
      title: 'Password Reset | SmartBite for Vendors',
      slug: `pages/password-reset`
    });

    this.authService.getToken().subscribe(token => {
      this.realToken = token;
      this.loginReq.token = this.realToken.token;
    });
  }

  changePass() {
    if (this.loginReq.password === this.loginReq.confirmPassword) {
      this.submitted = true;
      delete this.error;
      this.authService.resetPassword('email', this.loginReq).subscribe(
        (result: NbAuthResult) => {
          if (result.isSuccess() && result.getResponse().body.success) {
            this.user.passwordReset = false;
            this.authService.refreshToken('email', this.loginReq.token).subscribe(
              (result: NbAuthResult) => {
                if (result.isFailure()) {
                  return alert(this.utilService.getTranslation('terms.error1'));
                }
  
                const body = result.getToken();
                this.token.set(body).subscribe();
                this.router.navigate(['/pages/dashboard']).finally(() => location.reload());
              }
            );
            // this.router.navigate(['/pages/terms']);
          }
        },
        error => this.error = error.error.error.description
      );
    }
  }
}
